import CopyIcon from '@mui/icons-material/FileCopy';
import { IconButton } from '@mui/material';
import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import type { CopyButtonProps } from './copy-button-hook.js';

export type CopyButtonOwnProps = {
  readonly text: string;
  readonly onCopy?: () => void;
  readonly 'data-testid'?: string;
};

/**
 * A button that copies text to the clipboard when clicked.
 */
const CopyButton = React.forwardRef<HTMLButtonElement, CopyButtonProps>(({ text, handleCopy, testId }, ref) => {
  return (
    <CopyToClipboard text={text} onCopy={handleCopy}>
      <IconButton ref={ref} title="Copy" size="large" sx={{ p: 1 }} data-testid={testId}>
        <CopyIcon color="primary" fontSize="small" />
      </IconButton>
    </CopyToClipboard>
  );
});

export default CopyButton;
